module.exports = __webpack_public_path__ + "static/media/frutiger-45light.09c9dc3e.ttf";